import React from 'react';
import { Card, Button } from '@ui';

export interface CTABandProps {
  heading: string;
  description: string;
  primaryLabel: string;
  primaryHref: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  className?: string;
  headingType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const CTABand: React.FC<CTABandProps> = ({
  heading,
  description,
  primaryLabel,
  primaryHref,
  secondaryLabel,
  secondaryHref,
  className = '',
  headingType = 'h3',
}) => {
  return (
    <Card className={`cta${className ? ' ' + className : ''}`}>
      <div>
        {React.createElement(headingType, null, heading)}
        <p>{description}</p>
      </div>
      <div className='row btn-row'>
        <Button label={primaryLabel} className='btn-primary' as='a' href={primaryHref} />
        {secondaryLabel && secondaryHref && (
          <Button label={secondaryLabel} className='btn-secondary' as='a' href={secondaryHref} />
        )}
      </div>
    </Card>
  );
};

export default CTABand;
